module.exports = {"370704003":"凤凰街道","370704004":"坊安街道","370704005":"坊城街道","370704006":"九龙街道","370704007":"黄旗堡街道","370704008":"太保庄街道","370704009":"王家庄街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370704.json
// module id = 1414
// module chunks = 0